import { loadCyclewayLayer } from "./layerCycleway";

// Code catalog mapping a group's stable `key` (from the `groups` table) to
// the map layer it toggles. Which groups exist, their order and translated
// label come from the database (see api.groups()) — this registry only
// supplies the actual layer-loading behavior, which can't live in the DB.
// A group without an entry here is still shown as a toggle, it just has no
// effect on the map yet.
export const overlayLayers = {
  cycling: loadCyclewayLayer,
  // hiking: loadHikingLayer,
};
